import React from "react";

import { PostOpDetail } from "../user";

export default function Detail(props) {
  return <PostOpDetail isAdmin {...props} />;
}
